<template>
  <div class="assets">
    <template v-if="isLoading">
      <c-row>
        <c-col>
          <h4 class="text-h6">Getting assets...</h4>
        </c-col>
      </c-row>
    </template>
    <template v-else>
      <c-row class="mb-4">
        <c-col>
          <c-button-group class="float-right">
            <c-button v-show="$auth.check('organisation-admin')" color="primary" @click="showCreate = true">
              New Asset
            </c-button>
          </c-button-group>
        </c-col>
      </c-row>
      <c-row>
        <c-col>
          <c-card>
            <c-card-body>
              <c-data-table
                :items="assets"
                :fields="fields"
                :table-filter="{ placeholder: 'Find asset', label: ' ' }"
                items-per-page-select
                :items-per-page="20"
                hover
                sorter
                pagination
                responsive
              >
                <template #no-items-view>
                  <p class="text-center p-5 h3">No assets were found matching that search.</p>
                </template>
                <template #licenceName="{item}">
                  <td>
                    <a href="#" @click="selectedAsset = item; showView = true;">{{ item.licenceName }}</a>
                  </td>
                </template>
                <template #sites="{item}">
                  <td>
                    {{ item.sites.length }}
                  </td>
                </template>
                <template #clients="{item}">
                  <td>
                    {{ item.clients.length }}
                  </td>
                </template>
                <template #assetPurchased="{item}">
                  <td>
                    {{ item.assetPurchased ? 'Y' : 'N' }}
                  </td>
                </template>
                <template #createdAt="{item}">
                  <td>
                    {{ item.createdAt | dateFormat }}
                  </td>
                </template>
                <template #licenceStartDate="{item}">
                  <td>
                    {{ item.licenceStartDate | dateFormatNoTime }}
                  </td>
                </template>
                <template #licenceRenewDate="{item}">
                  <td>
                    {{ item.licenceRenewDate | dateFormatNoTime }}
                  </td>
                </template>
              </c-data-table>
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
    </template>
    <create-asset :show="showCreate" @close="showCreate = false" @created="fetchData" />
    <view-asset :show="showView" @close="showView = false" @created="fetchData" v-if="selectedAsset" :asset="selectedAsset" />
  </div>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';
import { getCompanyId } from '@/libs/user/getCompanyId';
import CreateAsset from '../components/asset/create.vue';
import ViewAsset from '../components/asset/view.vue';
import { dateFormatNoTime } from '@/filters';

export default {
  name: 'LicenceList',
  components: { CreateAsset, ViewAsset },
  data() {
    return {
      showCreate: false,
      showView: false,
      isLoading: true,
      selectedAsset: null,
      assets: [],
      organisationId: null,
      fields: [
        { key: 'entityType', label: 'Asset Type' },
        { key: 'licenceName', label: 'Name' },
        { key: 'sites', label: 'Sites' },
        { key: 'clients', label: 'Clients' },
        { key: 'licenceStartDate', label: 'Start' },
        { key: 'licenceRenewDate', label: 'End' },
        { key: 'assetPurchased', label: 'Purchased' },
      ],
    };
  },
  created() {
    this.organisationId = getCompanyId(this.$store);
    this.fetchData();
  },
  methods: {
    dateFormatNoTime,
    getBadge(status) {
      return status ? 'success' : 'secondary';
    },
    clientError(error) {
      this.$store.commit('addErrorMessage', {
        header: 'Error getting assets',
        message: error && error.message ? error.message : 'There was a problem getting your list of assets.',
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .get(buildEndpoint('asset/list/'))
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.assets = response.data.data;
          } else {
            this.clientError();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.clientError(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  margin-bottom: 20px;
}
.assets-list {
  min-height: 400px;
}
.no-data {
  p {
    text-align: center;
    padding: 40px;
    font-weight: bold;
  }
}
</style>
